import { Component, OnInit, Input, OnDestroy, ElementRef, ViewChild, HostListener, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../services/User.service';
import { GeneralService } from '../services/SystemSettings/General.service';
import { Subscription } from 'rxjs';
import { SwitchMarketComponent } from '../switch-market/switch-market.component';
import { AdminMarketInfoService } from '../services/SystemSettings/AdminMarketInfo.service';
import { OperationRentalService } from '../services/Operations/Rentals.service';
import { AutomaticRentRenewalService } from '../services/Operations/AutomaticRentRenewal.service';
import { AdminSetupService } from '../services/SystemSettings/AdminSetup.Service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],

})
export class TopBarComponent implements OnInit ,OnDestroy, OnChanges{
  isAdmin = false;
  isMobilRental=false;
  isShopperAdmission=false;
  isHover = false;
  shopperLicenseEnabled = false;
  mobilRentalLicenseEnabled = false;
  isMrDashboard=false;
  disableBlurEffect = false;
  disableBlurEffect2 = false;
  isRemovePopup = true;
  lastAccessed;
  userName="";
  arrPendingReminders: { name: string; deadline: string }[] = [];
  showArrReminderBanner = false;
  private arrReminderEnabled = false;
  private arrReminderAllowedUserIds: number[] = [];
  private currentUserId: number | null = null;
  private defaultMarketId: number | null = null;
  private subscriptions: Subscription[] = [];
  @ViewChild(SwitchMarketComponent, { static: true }) private SwitchMarketComponent: SwitchMarketComponent;
  @Input() AdminOrOps: string = 'Operation';
  @Input() CurrentPage: string = '';
  @Input() displayCompanyName;
  @Input() selectedMarketName;
  @Input() IsChangeTransactionDate:boolean;
  @Input() IsChangeUserId;
  public loaderIcon: Promise<boolean>;
  switchMarketOption: boolean;
  public marketList;
  displaySwitchStore = false;
  marketName;
  companyName;
  elementRef: any;
  renderer: any;
  @ViewChild('imgSwitchMkt', { static: false }) imgSwitchMktElement: ElementRef;
  imgSrc: string = 'data:image/svg+xml;base64,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';
  auctionLicenseEnabled: boolean = false;

  constructor(private router: Router,
    private userService: UserService,
    private adminMarketInfoService: AdminMarketInfoService,
    private operationRentalService:OperationRentalService,
    private generalService:GeneralService,
    private arrService: AutomaticRentRenewalService,
    private adminSetupService: AdminSetupService) {
    if (this.AdminOrOps === 'Admin') {
      this.isAdmin = true;
      this.switchMarketOption = false;
    } else if (this.AdminOrOps === 'Operation') {
      this.isAdmin = false;
      this.switchMarketOption = true;
    } else if(this.AdminOrOps==="MobilRental"){
      this.isAdmin = false;
      this.switchMarketOption = true;
      this.isMobilRental=true;
    }
    else if(this.AdminOrOps==="ShopperAdmission"){
      this.isAdmin = false;
      this.switchMarketOption = true;
      this.isShopperAdmission=true;
    }
  }

  ngOnInit() {
    this.subscriptions.push(
      this.arrService.arrPendingReminders$.subscribe(reminders => {
        this.arrPendingReminders = reminders;
        this.updateArrReminderBannerVisibility();
      })
    );
    this.getDefaultMarketId();
    this.getCompanyMarketList();
    this.getBTCloudLicensing();
    this.getUserDetailsFromUserID();
    if (this.selectedMarketName)
      this.marketName = this.selectedMarketName
    else
      this.getMarketName();
    this.getCompanyName();
    if (this.AdminOrOps === 'Admin') {
      this.isAdmin = true;
      this.switchMarketOption = false;
    } else if (this.AdminOrOps === 'Operation') {
      this.isAdmin = false;
      this.switchMarketOption = true;
    } else if(this.AdminOrOps==="MobilRental"){
      this.isAdmin = false;
      this.switchMarketOption = true;
      this.isMobilRental=true;
    }
    else if(this.AdminOrOps==="ShopperAdmission"){
      this.isAdmin = false;
      this.switchMarketOption = true;
      this.isShopperAdmission=true;
    }

    this.ToggleFullScreen();
    const currentUrl= this.router.url;
    if (currentUrl.includes('/mr/dashboard')) {
      this.isMrDashboard=true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.selectedMarketName){
    this.marketName = this.selectedMarketName
    }
  }

  getDefaultMarketId() {
   this.subscriptions.push(this.operationRentalService.getDefaultMarketId().subscribe((res: any) => {
      if (res) {
        this.lastAccessed = res;
        this.defaultMarketId = Number(res);
        this.loadArrReminderSettings();
      }
    }));
  }

  getBTCloudLicensing() {
    this.subscriptions.push(this.generalService.getBTCloudLicensing().subscribe((res: any) => {
       if (res) {
         this.shopperLicenseEnabled = res.EnableShopper;
         this.mobilRentalLicenseEnabled = res.EnableMR;
         this.auctionLicenseEnabled = res.EnableAuction;
       }
     }));
   }


  getUserDetailsFromUserID() {
    this.subscriptions.push(this.generalService.getUserDetailsFromUserID().subscribe((res: any) => {
      if (res) {
        this.userName = res.UserName;
        this.currentUserId = Number(res.Id);
        this.updateArrReminderBannerVisibility();
      }
    }));
  }

  private loadArrReminderSettings() {
    if (!this.defaultMarketId) {
      return;
    }

    this.subscriptions.push(this.adminSetupService.getOtherSettings(this.defaultMarketId).subscribe((res: any) => {
      this.arrReminderEnabled = !!res?.ArrReminderEnabled;
      const userIds = (res?.ArrReminderUserIds || '')
        .split(',')
        .map(id => parseInt(id, 10))
        .filter(id => !isNaN(id));
      this.arrReminderAllowedUserIds = userIds;
      this.updateArrReminderBannerVisibility();
    }));
  }

  private updateArrReminderBannerVisibility() {
    if (!this.arrReminderEnabled || !this.currentUserId || this.arrReminderAllowedUserIds.length === 0) {
      this.showArrReminderBanner = false;
      return;
    }

    this.showArrReminderBanner = this.arrReminderAllowedUserIds.includes(this.currentUserId)
      && this.arrPendingReminders.length > 0;
  }

  ToggleFullScreen(){
    if(this.isMobilRental){
      const elem = document.documentElement;

      if (document.fullscreenElement == null) {

          elem.requestFullscreen();

      }
    }else{
      if (document.fullscreenElement != null) {
      document.exitFullscreen();
      }
    }
  }

  hideSwitchMarketPopup(){
    this.getCompanyMarketList();
  }

  @HostListener('document:click', ['$event'])
  private documentClickHandler(event: TouchEvent): void {
    if (window.innerWidth < 992) {
      if (this.isRemovePopup) {
        const profileIcon = document.querySelector('.profile_user_img');
        const popupElement = document.querySelector('.profile_sec');
        if (!profileIcon.contains(event.target as Node) && !popupElement.contains(event.target as Node) && (document.querySelector('.mbltopHearder') as HTMLElement).classList.contains('profile_toggle')) {
          (document.querySelector('.mbltopHearder') as HTMLElement).classList.remove('profile_toggle');
          this.disableBlurEffect2 = !this.disableBlurEffect2;
        }
      }
      this.isRemovePopup = !this.isRemovePopup ? true : this.isRemovePopup;
    } else {
      const profileIcon = document.querySelector('.profile_user_img');
      const popupElement = document.querySelector('.profile_sec');

      if (!profileIcon.contains(event.target as Node) && !popupElement.contains(event.target as Node)) {
      let CssClassName = (event.target as Element).className;
      if(CssClassName.includes('nav-link active')){

      }
      else{
        (document.querySelector('.topHearder') as HTMLElement).classList.remove('profile_toggle');
        this.disableBlurEffect = !this.disableBlurEffect;
      }
    }
    }
  }

  @ViewChild('searchBarRef') searchBarRef: ElementRef;

  ngAfterViewInit() {
    if (this.CurrentPage === "Automatic Rent Renewal") {
      if (this.searchBarRef) {
        const nativeElement = this.searchBarRef.nativeElement as HTMLElement;
        if (nativeElement) {
          nativeElement.style.marginTop = '-10px';
        }
      }
    }
  }

  getMarketName() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.generalService.getMarketName().subscribe({
      next: (res: any) => {
        if (res) this.marketName = res;
        this.loaderIcon = Promise.resolve(false);
      },
      error: () => this.loaderIcon = Promise.resolve(false)
    });
    this.subscriptions.push(sub);
  }

  getCompanyName() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.generalService.getCompanyName().subscribe((res: any) => {
      if (res) {
        if (!this.isAdmin ) {
          this.companyName = res;
        }
        else {
          this.companyName = res;
        }
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  logout() {
    Swal.fire({
      title: $localize`Are you sure ?`,
      text: $localize`Log out!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`,

    }).then((result) => {
      if (result.value) {

      this.subscriptions.push( this.userService.clearToken().subscribe((res: any) => {

        this.router.navigate(['/login']);
       }));
      }else{
        return;
      }

    });

  }

  ProfileMenu(cls, temp?) {
    if(!temp){
      this.disableBlurEffect = !this.disableBlurEffect;
    }
    if(!temp && !this.disableBlurEffect){
      (document.querySelector('.topHearder') as HTMLElement).classList.remove(cls);
    } else {
      (document.querySelector('.topHearder') as HTMLElement).classList.add(cls);
    }
    if(temp){
      (document.querySelector('.topHearder') as HTMLElement).classList.remove(cls);
    }
    if((document.querySelector('.topHearder') as HTMLElement)){
      (document.querySelector('.topHearder') as HTMLElement).classList.remove('notification_toggle');
      (document.querySelector('.topHearder') as HTMLElement).classList.remove('message_toggle');
    }
    const notClslist = (document.querySelector('.head_notification') as HTMLElement);
    if (notClslist) {
      (document.querySelector('.head_notification') as HTMLElement).classList.remove('selected');
    }
  }

  mblProfileMenu(cls, temp?) {
    if(!temp){
      this.disableBlurEffect2 = !this.disableBlurEffect2;
    }
    if(!temp && !this.disableBlurEffect2){
      (document.querySelector('.mbltopHearder') as HTMLElement).classList.remove(cls);
      this.isRemovePopup = true;
    } else {
      (document.querySelector('.mbltopHearder') as HTMLElement).classList.add(cls);
      this.isRemovePopup = false;
    }
    if(temp){
      (document.querySelector('.mbltopHearder') as HTMLElement).classList.remove(cls);
    }
    if((document.querySelector('.mbltopHearder') as HTMLElement)){
      (document.querySelector('.mbltopHearder') as HTMLElement).classList.remove('notification_toggle');
      (document.querySelector('.mbltopHearder') as HTMLElement).classList.remove('message_toggle');
    }
    const notClslist = (document.querySelector('.head_notification') as HTMLElement);
    if (notClslist) {
      (document.querySelector('.head_notification') as HTMLElement).classList.remove('selected');
    }
  }

  removeNotify_pop() {
    if ((document.querySelector('.topHearder') as HTMLElement).classList.contains('profile_toggle')) {
      this.showPopupMessage('profile_toggle');
      (document.querySelector('.containerForRemoveNotify') as HTMLElement).classList.remove('Open');
    }
  }

  showPopupMessage(cls) {
    (document.querySelector('.topHearder') as HTMLElement).classList.toggle(cls);
    (document.querySelector('.containerForRemoveNotify') as HTMLElement).classList.toggle('Open');
    (document.querySelector('.topHearder') as HTMLElement).classList.remove('profile_toggle');
  }

  onclickSwitchMarket() {
    this.SwitchMarketComponent.openSwitchmarketModal();
    this.removeNotify_pop();
  }

  getCompanyMarketList() {
    this.loaderIcon = Promise.resolve(true);
   this.subscriptions.push(this.adminMarketInfoService.getMarketList().subscribe((res: any) => {
      this.marketList = [];
      if (res) {
        if (res.length > 0) {
          res.map((el, i) => {
            const ob = {
              MarketId: el.MarketId,
              MarketName: el.MarketName
            }
            this.marketList.push(JSON.parse(JSON.stringify(ob)));
          });
        }

        if (res.length > 1)
          this.displaySwitchStore = true;
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  hoverSwitchMarket() {
    this.disableBlurEffect = true;
    if (this.imgSwitchMktElement) {
      const imgSwitchMkt = this.imgSwitchMktElement.nativeElement as HTMLImageElement;
      imgSwitchMkt.src = 'data:image/svg+xml;base64,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';
    }
  }

  hoverLeaveSwitchMarket() {
    this.disableBlurEffect = false;
    if (this.imgSwitchMktElement) {
      const imgSwitchMkt = this.imgSwitchMktElement.nativeElement as HTMLImageElement;
      imgSwitchMkt.src = 'data:image/svg+xml;base64,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';
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}
